const common = require('./common.json');
const goods = require('./goods.json');

export default {
  common,
  goods,
};
